module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitle",
    attrs: {
      "id": "contents"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00"
    }
  }, [_vm._v("PROLOGUE: THE BIRTH OF A GHOST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("1: LAPSEWOOD’S PAPERWORK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_vm._v("2: THE BODY IN THE COFFIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03"
    }
  }, [_vm._v("3: THE BEAUTY OF ALICE BIGGINS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04"
    }
  }, [_vm._v("4: UNCLE JACK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05"
    }
  }, [_vm._v("5: PENHALIGAN’S PROBLEM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: MR. CONSTABLE’S GOOD NATURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: GENERAL COLT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: THE NEW TENANTS OF AYSGARTH HOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: THE ANGER OF VIOLA TRUMP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: THE BOY TANNER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: MR. GLIDDON’S DYING WISH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12: LADY AYSGARTH’S DIARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13: THE MAN IN GRAY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14: THE BLACKENED CHURCH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15: THE DEATH OF A GHOST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16: A TRAIL OF INFECTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17: DORIS MCNALLY’S NEW RESIDENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18: THE BELL TOWER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19: THE DISAPPEARANCE OF LI’L MAGS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20: THE BOY IN THE CHURCH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21: LAPSEWOOD’S RETURN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22: CHARLIE AND JACK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23: BREAKFASTING ALONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24: THE VAULT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25: THE EXORCISM OF ST. WINIFRED’S SCHOOL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26: A PARENT’S PAST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27: MRS. PRINGLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28: THE PARISIAN PROBLEM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29: CLARA’S LIST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30: THE BURIAL OF MR. GLIDDON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31: FLOUTING PROCEDURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32: A VISITOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33: THE END OF NELL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34: MR. STERNWELL’S LAST WILL & TESTAMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35: GRUNT IN LONDON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36: WHAT IF …")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37: STALEMATE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38: JACK’S LAST BREAKFAST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39: DESTINY FOR THE DEAD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40: THE LAST WORDS OF ENFORCER DAWLISH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41: ONE TREE HILL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42: BREAKING OUT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43: THE GIRL IN THE KITCHEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44: EMILY’S NEW HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45: THE RESPECTABLE MR. REEVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46: LAST CALL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47: MR. REEVE’S PLACE OF BUSINESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48: THOSE WHO MOURN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49: BREAKING IN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50: SAM AND TANNER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51: THE KITCHEN KILLER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52: FRESH BLOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53: THE CENTRAL RECORDS LIBRARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54: A NEW GHOST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55: AN APPRENTICESHIP OF THIEVERY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56: THE RESPONSIBILITY OF MURDER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57: POOR MRS. PRESTON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58: THE RETURN OF INSPECTOR SAVAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59: A FRENCH INTRUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60: ALWAYS ALICE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61: EMILY’S PLAY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62: THE BALLAD OF PADDY O’TWAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63: THE HELLHOUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64: A WIDOW’S GRIEF")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65: COLONEL PENHALIGAN’S AGENDA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66: THE WORK OF THE DEVIL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67: AN ENTERTAINING EXORCISM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68: THE ELEVENTH HOLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69: A FATHER’S GUILT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70: GRUNT’S DECLINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71: AN UNEXPECTED VISITOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72: JACK’S FINAL VICTIM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73: THE FRENCH ANGEL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74: THE NEW RESIDENT OF AYSGARTH HOUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75: JACK’S FUNERAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76: THE ENDLESS CORRIDOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77: HONOR OAK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUTHOR’S NOTE: THE WRITING OF CONSTABLE & TOOP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0